import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Menu, MenuItems } from '../../core/menu/menu-items/menu-items';
import { AuthenticationService } from '../../core/services/auth.service';
import { Subject } from 'rxjs';
import { ModalService } from '../../core/services/modal.service';
import { ProductService } from '../../core/services/product.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {


  public titleModal: string;
	public contentModal: string;
	public modalYesNo: boolean = true;

	public yesModalCallback: (r:Router) => void;
  private modal
  constructor(private router: Router, private authService: AuthenticationService,private injector: Injector, public modalService: ModalService, private productService: ProductService) { 
    this.modal = this.injector.get(NgbModal);
  }
  public tipologiaVariante: string;
  public vociMenu: Menu[];
  titolo: string;
  daEliminare:string;
  @ViewChild('modalDeleteContent')
  private modalDeleteContent: TemplateRef<any>;

  @ViewChild('modalAggiungiVariante')
  private modalAggiungiVariante: TemplateRef<any>;

  @ViewChild('modalContent')
	private modalContent: TemplateRef<any>;

  ngOnInit(): void {

    if(!this.authService.isAdmin())
    {
      this.router.navigate(['/home']);
    }

    this.vociMenu = [{
      state: "/admin/dashboard",
      name: "Dashboard",
      type: "link",
      categoria: "dashboard"
    },
    {
      state: "/admin/categorie/lista",
      name: "Categorie",
      type: "link",
      categoria: "prodotti"
    }, {
      state: "/admin/prodotti/lista",
      name: "Prodotti",
      type: "link",
      categoria: "prodotti"
    },
    {
      state: "/admin/produttori/lista",
      name: "Produttori",
      type: "link",
      categoria: "prodotti"
    },
    {
      state: "/admin/articolo/lista",
      name: "Blog",
      type: "link"
    },
    {
      state: "/admin/ordini/lista",
      name: "Ordini",
      type: "link",
      categoria: "vendite"
    },];
    this.vociMenu.forEach(element => {
      if(this.router.url.indexOf(element.state)>=0){
        element.active = true;
        this.titolo = element.name as string;
      }
    });
  }

  public openDeleteModal() {
    
		this.modal.open(this.modalDeleteContent, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => {
				
			},
			(reason) => {
				
			},
		);
	}

  public closeDeleteModal() 
  {
    
		this.modal.dismissAll();
	}

  public getDashBoardMenu(){
    return this.vociMenu.filter(x=>x.categoria == "dashboard");
  }

  public getProdottiMenu(){
    return this.vociMenu.filter(x=>x.categoria == "prodotti");
  }

  public getVenditeMenu(){
    return this.vociMenu.filter(x=>x.categoria == "vendite");
  }

  public getOtherMenu(){
    return this.vociMenu.filter(x=>x.categoria== null);
  }

  public YesClick(fn: (r:Router) => void): any {
    fn(this.router);
	this.closeDeleteModal();
}

public openModal() {      
    this.modal.open(this.modalDeleteContent, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        
      },
      (reason) => {
        
      },
    );
  }

  public openGenericModal() {      
    this.modal.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        
      },
      (reason) => {
        
      },
    );
  }

  public openAddTipologiaVarianteModal() {  
    this.tipologiaVariante = '';    
    this.modal.open(this.modalAggiungiVariante, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => 
      {
        if(result == 'Save click')
        {
          console.log(this.tipologiaVariante);
          if(this.productService.varianti!= null)
          {
            this.productService.varianti.push({
              tipologia : this.tipologiaVariante
            })
            
          }else{
            this.productService.varianti = [{
              tipologia : this.tipologiaVariante
            }];
          }

          var event = new CustomEvent("varianteChange");
          window.dispatchEvent(event);
        }
      },
      (reason) => 
        {
        
      },
    );
  }
}
